var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-3 col-xl-2 col-sm-12 col-form-label",attrs:{"name":_vm.name}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-xl-10 col-sm-12"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }